export enum LessonStatus {
	Scheduled = 1,
	Rescheduled = 2,
	PendingReschedule = 3,
	AwaitingPayment = 4,
	Completed = 5,
	Unverified = 6,
	Canceled = 7
}
